// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import { Component } from "react";
/** @jsx jsx */ import { Global, css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { Logo } from "../components/Partials/Logo";
import { Top } from "../components/Partials/Top";
import { Header } from "../components/Header/Header";
import { PrimaryNav } from "../components/PrimaryNav/PrimaryNav";
import { Background } from "../components/Partials/Background";
import { Ui } from "../components/Partials/Ui";
import "normalize.css"; // Note this

import {
  zindex,
  sizes,
  expandValue,
  colors,
  fonts,
  breakpoints,
  transition
} from "../helpers/theme";

class AppContainer extends Component {
  render() {
    let hudStyles = props => css`
      z-index: ${zindex.hud};
      position: fixed;
      height: ${expandValue(sizes.space * 3)};
      width: 100%;
      pointer-events: none;
      @media (min-width: ${expandValue(breakpoints[3])}) {
        height: ${expandValue(sizes.space * 6)};
      }
    `;
    let HudStyled = styled("div")`
      ${hudStyles}
    `;

    let coverStyles = props => css`
      z-index: ${zindex.cover};
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 0;
      width: 100%;
    `;
    let CoverStyled = styled("div")`
      ${coverStyles}
    `;

    let logoStyles = props => css`
      position: fixed;
      width: ${expandValue(sizes.space * 2)};
      height: ${expandValue(sizes.space * 3)};
      @media (min-width: ${expandValue(breakpoints[3])}) {
        width: ${expandValue(sizes.space * 4)};
        height: ${expandValue(sizes.space * 6)};
      }
    `;
    let LogoStyled = styled("div")`
      ${logoStyles}
    `;

    let TopStyles = props => css`
      width: ${expandValue(sizes.space * 2)};
      height: ${expandValue(sizes.space * 2)};
      position: fixed;
      bottom: 0;
      ${transition("transform", sizes.timer + "ms")}
      display: flex;
      align-content: center;
      justify-content: center;
      &.Banished {
        transform: translateY(100%);
      }
      @media (min-width: ${expandValue(breakpoints[3])}) {
        width: ${expandValue(sizes.space * 4)};
        height: ${expandValue(sizes.space * 4)};
      }
    `;
    let TopStyled = styled("div")`
      ${TopStyles}
    `;

    return (
      <div>
        <Global
          styles={css`
            html,
            body {
              height: 100%;
              font-family: ${fonts.default};
              background: ${colors.black};
              font-size: ${expandValue(sizes.fontSize)};
              line-height: ${sizes.lineHeight};
              &.noScroll {
                overflow: hidden;
              }
            }

            html {
              color: ${colors.white};
              font-size: 100%;
              box-sizing: border-box;
            }

            *,
            *:before,
            *:after {
              box-sizing: inherit;
              -webkit-tap-highlight-color: ${colors.primary};
            }
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            p,
            dl,
            dd,
            dt,
            div,
            img {
              margin: 0;
              padding: 0;
            }
            ol,
            ul {
              margin: 0;
              padding: 0;
              list-style: none;
              li {
                margin: 0;
                padding: 0;
              }
            }
            .page-container {
              width: 100%;
              height: 100%;
            }
            .page-content-enter {
              opacity: 0.01;
              transform: translateY(5vw) scale(0.95);
              transform-origin: top center;
            }

            .page-content-enter-active {
              opacity: 1;
              transform: translateY(0) scale(1);
              ${transition("transform", sizes.timer * 2 + "ms")}
              transform-origin: top center;
            }

            .page-content-exit {
              opacity: 1;
              transform: translateY(0) scale(1);
              transform-origin: top center;
            }

            .page-content-exit-active {
              opacity: 0.01;
              transform: translateY(5vw) scale(0.95);
              ${transition("transform", sizes.timer * 2 + "ms")}
              transform-origin: top center;
            }
          `}
        />
        <Background />
        <HudStyled id="Hud">
          <PrimaryNav />
          <Header />
        </HudStyled>
        <Ui id="Ui">{this.props.children}</Ui>
        <CoverStyled id="Cover">
          <LogoStyled id="Logo">
            <Logo />
          </LogoStyled>
          <TopStyled id="Top">
            <Top />
          </TopStyled>
        </CoverStyled>
      </div>
    );
  }
}

export default AppContainer;



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js